window.addEventListener('DOMContentLoaded', () => {

    // get lookeen__comparision-block-blue and lookeen__comparision-block-grey
    const comparisonBlock = document.querySelector('.lookeen__comparision-block-blue');
    const comparisonBlockGrey = document.querySelector('.lookeen__comparision-block-grey');

    if (!comparisonBlock || !comparisonBlockGrey) {
        return;
    }

    const syncHeights = () => {
        // Get all the uls in both comparison blocks
        const comparisonBlockLists = comparisonBlock.querySelectorAll('ul');
        const comparisonBlockGreyLists = comparisonBlockGrey.querySelectorAll('ul');

        // Ensure both blocks have the same number of ul elements
        if (comparisonBlockLists.length !== comparisonBlockGreyLists.length) {
            console.error('Both blocks must have the same number of ul elements.');
            return;
        }

        // Reset all li heights to auto before recalculating
        comparisonBlockLists.forEach((ul, index) => {
            const lisBlue = ul.querySelectorAll('li');
            const lisGrey = comparisonBlockGreyLists[index].querySelectorAll('li');
            
            lisBlue.forEach(li => li.style.height = 'auto');
            lisGrey.forEach(li => li.style.height = 'auto');
        });

        // Loop through each ul and synchronize li heights between blue and grey blocks
        comparisonBlockLists.forEach((ul, index) => {
            const lisBlue = ul.querySelectorAll('li');
            const lisGrey = comparisonBlockGreyLists[index].querySelectorAll('li');

            // Ensure both ul elements have the same number of li elements
            if (lisBlue.length !== lisGrey.length) {
                console.error(`UL at index ${index} does not have the same number of LI elements in both blocks.`);
                return;
            }

            // Loop through each li and synchronize heights
            lisBlue.forEach((liBlue, liIndex) => {
                const liGrey = lisGrey[liIndex];

                // Calculate the maximum height between the two corresponding lis
                const maxHeight = Math.max(liBlue.clientHeight, liGrey.clientHeight);

                // Set the height of both lis to the maximum height
                liBlue.style.height = `${maxHeight}px`;
                liGrey.style.height = `${maxHeight}px`;
            });
        });
    };

    // Run the height synchronization when the page loads
    syncHeights();

    // Re-run the height synchronization on window resize
    window.addEventListener('resize', () => {
        syncHeights();
    });
});
